<script setup>
import { getI18n } from '@/plugins/i18n'

import { formatShortDate, formatShortDateTime } from '@/lib/utils'

import InfoBox from '@/components/shared/InfoBox.vue'

const props = defineProps({
  updatedAt: {
    type: String,
    default: null,
  },
  ratesDate: {
    type: String,
    default: null,
  },
})

const i18n = getI18n()
</script>
<template>
  <div class="row items-center no-wrap">
    <q-icon
      name="mdi-bank-outline"
      color="primary"
      size="sm"
      class="q-mr-sm"
    />
    <div v-if="props.updatedAt" class="text-subtitle2 col-shrink">
      {{ i18n.t('company.exchangeRates.lastEcbUpdate') }}:
      <span class="text-weight-bold">{{ formatShortDateTime(props.updatedAt) }}</span>
      <span class="text-caption text-grey-7 q-ml-sm">{{ i18n.t('company.exchangeRates.ecbRatesOf', { date: formatShortDate(props.ratesDate) }) }}</span>
    </div>
    <div v-else class="text-subtitle2 col-shrink">{{ i18n.t('company.exchangeRates.noEcbRates') }}</div>
    <info-box popup class="q-ml-xs">
      <div>{{ i18n.t('company.exchangeRates.manualRatesInfo') }}</div>
      <div class="q-mt-xs">{{ i18n.t('company.exchangeRates.ecbRatesInfo') }}</div>
    </info-box>
  </div>
</template>
